import { render, staticRenderFns } from "./DisclaimerButton.vue?vue&type=template&id=0d3813ae"
import script from "./DisclaimerButton.vue?vue&type=script&lang=ts&setup=true&generic=true"
export * from "./DisclaimerButton.vue?vue&type=script&lang=ts&setup=true&generic=true"
import style0 from "./DisclaimerButton.vue?vue&type=style&index=0&id=0d3813ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports